import { connect } from 'react-redux'
import Topbar from './Topbar'

const mapStateToProps = ({ authentication: { user: { name, email } } }) => {
	return { name, email }
};

export default connect(
	mapStateToProps
)(Topbar);



// WEBPACK FOOTER //
// ./src/components/topbar/TopbarContainer.js